import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=bcc6577c&scoped=true"
import script from "./Voice.vue?vue&type=script&lang=js"
export * from "./Voice.vue?vue&type=script&lang=js"
import style0 from "./Voice.vue?vue&type=style&index=0&id=bcc6577c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc6577c",
  null
  
)

export default component.exports